RivalIQ.apps.AdsInsights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const TableView = RivalIQ.apps.Dashboard.widgets.MetricTable.extend({

        rowClassName: function () {
            const me = this;

            // only ad objects have an on row click action
            return (me.dashboardModel.baseMetric.childObjectType ? 'pointer' : '');
        },

        /*
         * In addition to the bounds calculated by the superclass, calculates the max string width of
         * each column, which is useful for bar rows.
         */
        _setBounds: function (rows) {
            const me = this;

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype._setBounds.apply(me, arguments);

            me.labelBounds = _.reduce(rows, function (arr, row, rowIdx) {
                if (!row) {
                    return arr;
                }

                return _.map(row, function (data, columnIdx) {
                    const metric = me.getMetricModel(rowIdx, columnIdx);
                    if (!metric.get('showProgressBar')) {
                        return;
                    }

                    const rowStringLength = _.size(metric.format(_.last(data)));
                    return Math.max(rowStringLength, arr[columnIdx] || 0);
                });
            }, []);
        },

        getCellView: function (data, rowIndex, columnIndex) {
            const me = this;

            if (columnIndex === 0) { // the name column is special
                return App.views.AdObjectNameCell.extend({
                    dashboardModel: me.dashboardModel
                });
            } else {
                const property = me.collection.at(columnIndex).get('property');
                if (_.includes(['ad_body', 'ad_title'], property)) {
                    return App.views.AdsTextTableCell;
                } else {
                    return App.views.AdsTableCell;
                }
            }
        },

        onRowClick: function (data, e) {
            const me = this;

            const target = $(e.target);
            if (target.is('a')) {
                // don't pop the modal if the user clicked on a link (which will take them away from the page).
                return;
            }

            const adObject = data[0][1];
            if (!adObject.isBreakdown) {

                RivalIQ.execute('show:modal', new App.views.AdObjectDetailsModal({
                    dashboardModel: me.dashboardModel,
                    adObject: adObject
                }));
            }
        },

        loadData: function () {
            const me = this;
            const metrics = me.dashboardModel.metricsCollection;
            const submetrics = me.dashboardModel.submetricsCollection;

            const fetchAttrs = me.getFetchAttributes();

            let startedBuffering = false;
            if (!RivalIQ.data.CacheLayer.isBuffering()) {
                startedBuffering = true;
                RivalIQ.data.CacheLayer.startBuffering();
            }

            const fetches = [metrics.fetch(fetchAttrs)];
            if (submetrics) {
                fetches.push(submetrics.fetch(fetchAttrs));
            }

            if (me.dashboardModel.metricObservationsGenerator) {
                fetches.push(me.dashboardModel.metricObservationsGenerator.generateObservations());
            }

            if (startedBuffering) {
                RivalIQ.data.CacheLayer.stopBuffering();
                RivalIQ.data.CacheLayer.flush();
            }

            return $.when.apply(undefined, fetches)
                .then(function (metrics, submetrics) {
                    me.collection = metrics;
                    if (submetrics) {
                        submetrics.forEach(function (submetric) {
                            const metric = me.collection.at(submetric.get('columnIdx'));
                            metric.submetrics = _.union(metric.submetrics, [submetric]);
                        });
                    }
                    me.dimensions = []; // table base-class relies on this existing.
                });
        },

        onAllRowsRendered: function () {
            const me = this;

            RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.onAllRowsRendered.apply(me, arguments);

            me.$el.find('.ad-status').popover({
                html: true,
                placement: 'right'
            });
        }
    });

    const AdObjectsTableWidget = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        view: TableView,

        isSupported: _.constant(true),

        tableClassName: function () {
            const me = this;
            const classes = ['table-fix'];

            if (!me.metric.breakdownName) {
                classes.push('table-hover');
            }
            return classes.join(' ');
        },

        processProps: function (props) {
            const me = this;

            me.metric = RivalIQ.metric.build(props, _.clone(me.baseMetric));

            const selectedMetrics = _.map(me.getProp('tableMetrics'), function (metric) {
                return _.defaults({
                    header: {
                        className: (metric.showProgressBar ? 'progress-bar-metric' : 'no-progress-bar-metric')
                    }
                }, metric);
            });
            const allColumns = [{
                property: 'adObject',
                name: 'Name',
                sortable: false,
                header: {
                    className: 'post-content-header'
                },
                submetrics: ['spend_pct_of_overall']
            }].concat(selectedMetrics);

            const metrics = RivalIQ.metric.build(me.metric, allColumns);

            const submetrics = _.reduce(metrics, function (memo, metric, columnIdx) {
                return _.reduce(metric.submetrics, function (memo, submetricProperty) {
                    let submetric = {
                        property: submetricProperty,
                        columnIdx: columnIdx
                    };

                    submetric = RivalIQ.metric.build(me.metric, submetric);
                    return memo.concat(submetric);
                }, memo);
            }, []);

            me.metricsCollection = new RivalIQ.collections.MetricDefinitions(metrics);

            if (!_.isEmpty(submetrics)) {
                me.submetricsCollection = new RivalIQ.collections.MetricDefinitions(submetrics);
            }

            return RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.processProps.apply(me, arguments);
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'facebookAdsInsightsGenerator',
                metric: me.getExportMetricDefinitions('csv'),
                includeDimensionColumn: false
            };
        },

        getExportMetricDefinitions: function (format) {
            const me = this;

            const metrics = me.metricsCollection.invoke('serialize', format);
            const sortColumns = me.metricsCollection.getColumnSortOrder(me.getProp('orderBy'));
            const orderBy = me.metricsCollection.getOrderBy(sortColumns);

            return _.map(metrics, function (metric) {
                return _.extend(metric, {
                    orderBy: orderBy,
                    limit: -1,
                    submetrics: undefined,
                    filterZeroSpend: false
                });
            });
        }

    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ADS_INSIGHTS_AD_OBJECT_TABLE, AdObjectsTableWidget);
});
